<template>
<div class="chapter">
<div class="inner_page">
<p class="copyx"><img alt="image" src="images/img2.jpg"/></p>
<p class="copy1">Copyright © 2019 by Dan Roberts</p>
<p class="copy">All rights reserved.</p>
<p class="copy1">Published by Familius LLC, <a href="http://www.familius.com" target="_blank">www.familius.com</a></p>
<p class="copy1">Familius books are available at special discounts for bulk purchases, whether for sales promotions or for family or corporate use. For more information, contact Familius Sales at 559-876-2170 or email <a href="mailto:orders@familius.com">orders@familius.com</a>.</p>
<p class="copy1">Reproduction of this book in any manner, in whole or in part, without written permission of the publisher is prohibited.</p>
<p class="copy1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy">2018963781</p>
<p class="copy1">Print ISBN 9781641701235</p>
<p class="copy">Ebook ISBN 9781641701723</p>
<p class="copy1">Printed in China</p>
<p class="copy1">Edited by Joseph Webb and Alison Strobel</p>
<p class="copy">Cover design by David Miles</p>
<p class="copy">Book design by David Miles and Derek George</p>
<p class="copy1">Images sourced from WikiCommons, Library of Congress, or licensed from Shutterstock.</p>
<p class="copy1">10 9 8 7 6 5 4 3 2 1</p>
<p class="copy1">First Edition </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?6447f210